import NavButton from "@/pages/(app)/returns/view/components/return-nav/nav-button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useReturnRequestsNavigation } from "../../../list/hooks/use-filtered-return-requests";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useNavigate } from "react-router-dom";
import { useBoolean } from "@/hooks/use-boolean";

type NavButtonNextAndPrevProps = {
  returnId: string;
};

export default function NavButtonNextAndPrev({
  returnId,
}: NavButtonNextAndPrevProps) {
  const isLoading = useBoolean(false);
  const { data: shop } = useCurrentShopSuspense();
  const { getNextId, getPreviousId, canGoNext, canGoPrevious, disabled } =
    useReturnRequestsNavigation(returnId);

  const navigate = useNavigate();

  const onPrevious = async () => {
    isLoading.setTrue();
    try {
      const previousId = await getPreviousId();
      if (previousId) {
        return navigate(`/shops/${shop.id}/returns/${previousId}`);
      }
    } catch (e) {
      console.error("Error fetching previous return request", e);
    } finally {
      isLoading.setFalse();
    }
  };

  const onNext = async () => {
    isLoading.setTrue();
    try {
      const nextId = await getNextId();
      if (nextId) {
        return navigate(`/shops/${shop.id}/returns/${nextId}`);
      }
    } catch (e) {
      console.error("Error fetching next return request", e);
    } finally {
      isLoading.setFalse();
    }
  };

  if (disabled) return null;

  return (
    <div className={"flex flex-row items-center gap-2"}>
      {canGoPrevious && (
        <NavButton
          keyboardKey={"k"}
          onClick={onPrevious}
          isLoading={isLoading.value}
        >
          <ChevronUp className={"h-4 w-4"} />
        </NavButton>
      )}
      {canGoNext && (
        <NavButton
          keyboardKey={"j"}
          onClick={onNext}
          isLoading={isLoading.value}
        >
          <ChevronDown className={"h-4 w-4"} />
        </NavButton>
      )}
    </div>
  );
}
